<template>
  <div class="nmz_imgscroll_wrap" >
    <template v-if="bg_img">
      <img :src="bg_img" class="bg" @click="click_bg" />
      <div style="position:absolute;bottom:0;">
        <Imgs :custom_color="true" :info="info" :data_list="data_list" />
      </div>
    </template>

    <template v-else>
      <Imgs :custom_color="true"  :info="info" :data_list="data_list" />
    </template>
  </div>
</template>
<script>


import Imgs from "./NzmImgScroll/Imgs";
import { getJSON, getJSONP } from "../../api/myaxios";
import { toRem, urlToWebp } from "../../tools/tpl";
import click_handler from "../../tools/mgtv/click";
import {openLink} from '../../tools/mgtv/link'
import { HIDE_COMP } from '../../constant/eventbus'


export default {
  name: "NzmImgScroll",
  components: {
    Imgs,
  },
  props: {
    info: {
      type: Object
    }
  },
  data: function() {
    return {
      data_list: null
    };
  },
  methods: {
    get_detail() {
      getJSON(
        "//vipact3.api.mgtv.com/api/v1/act/img/get",
        {
          act_name: this.info.act_name,
          invoker: window.gact.invoker,
          f_release: window.gact.f_release
        },
        10000,
        false,
        true
      ).then(res => {
        if (!res) {
          return;
        }
        if (res.ret === 0) {
          const list = res.data.list;
          if(list.length === 0){
            console.log('没有内容，隐藏模块', this.info.act_name)
            window.$bus.$emit(HIDE_COMP, this.info.act_name);
            return;
          }
          list.forEach(item => {
            item.img = urlToWebp(item.img);
          });
          this.data_list = list.slice(0, this.max_num);
        }
      });
    },
    click_bg() {
      click_handler(`${this.info.act_name_chn}-点击-背景`, () => {
        setTimeout(() => {
          openLink(this.info.config.bg_url);
        }, 200);
      });
    }
  },
  computed: {
    max_num: function () {
      return this.info.config.max_num || 999999;
    },
    bg_img(){
       return urlToWebp(this.info.config.bg_img)
    }
  },
  mounted() {
    this.get_detail();
  }
};
</script>


<style lang="stylus"  >
.nmz_imgscroll_wrap
    position relative
    .bg
      position relative
      display block
      width 100%
</style>
